// extracted by mini-css-extract-plugin
module.exports = {"templatesheight":"3.1875rem"};